/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  function payVideo() {
    document.querySelectorAll('.column__image_video').forEach(function (item) {
      const videoEl = item.querySelector('.video-wrapper video');
      item.onmouseenter = function () {
        if (videoEl) {
          videoEl.play();
          item.classList.add('playing');
        }
      };

      item.onmouseleave = function () {
        if (videoEl) {
          videoEl.pause();
          item.classList.remove('playing');
        }
      };
    });
  }

  payVideo();

  function pdpNavigation() {
    const productNavbar = document.querySelector('#product-navbar');
    if (!document.querySelector('.template-product') || !productNavbar) {
      return;
    }

    // 获取product-navbar-other下面的所有li
    const productNavbarLi = document.querySelectorAll(
      '.product-navbar-other li'
    );

    function removeActiceClass() {
      productNavbarLi.forEach((li) => {
        li.classList.remove('navbar-active');
      });
    }

    function scroll(target) {
      if (target === 'overview') {
        window.scrollTo({
          top: 0,
        });
      } else {
        if (target == 'review') {
          const el = document.querySelector('.jdgm-preview-badge');
          if (el) {
            el.click();
          }
          return
        }
        const targetDom = document.querySelector(`.product-${target}`);
        if (!targetDom) return;
        window.scrollTo({
          top: targetDom.offsetTop - 100,
        });
      }
    }

    // 给每个li添加点击事件
    productNavbarLi.forEach((li) => {
      li.addEventListener('click', (e) => {
        removeActiceClass();
        // 给点击的li添加active
        e.target.classList.add('navbar-active');
        // 获取属性
        const target = e.target.getAttribute('data-target');
        scroll(target);
      });
    });

    const specsDom = document.querySelector(`.product-specs`);
    const compareDom = document.querySelector(`.product-compare`);
    const faqDom = document.querySelector(`.product-faq`);
    const reviewDom = document.querySelector(`#judgeme_product_reviews`);

    const autoTrigger = (target) => {
      const targetDom = document.querySelector(`[data-target="${target}"]`);
      removeActiceClass();
      targetDom?.classList?.add('navbar-active');
    };

    // 给滚动事件添加节流
    function throttle(fn, delay) {
      let last = 0;
      return function () {
        const now = Date.now();
        if (now - last > delay) {
          fn();
          last = now;
        }
      };
    }
    function handleNav () {
      if (window.scrollY >= 0) {
        autoTrigger('overview');
      }
      //  判断targetDom是否滚动到窗口顶部
      if (specsDom) {
        if (window.scrollY >= specsDom.offsetTop - 300) {
          autoTrigger('specs');
        }
      }

      //  判断targetDom是否滚动到窗口顶部
      if (compareDom) {
        if (window.scrollY >= compareDom.offsetTop - 300) {
          autoTrigger('compare');
        }
      }

      if (reviewDom && reviewDom.style.display !== 'none') {
        if (window.scrollY >= reviewDom.offsetTop - 300) {
          autoTrigger('review');
        }
      }

      //  判断targetDom是否滚动到窗口顶部
      if (faqDom) {
        if (window.scrollY >= faqDom.offsetTop - 300) {
          autoTrigger('faq');
        }
      }
    }
    window.addEventListener(
      'scroll',
      throttle(function () {
        handleNav()
      }, 100)
    );

    document.addEventListener('load', function () {
      ['specs', 'compare', 'review'].forEach(function (item) {
        let el = document.querySelector('.product-' + item);
        const elLi = document.querySelector('.product-navbar-other [data-target="'+ item +'"]');
        if (!el) {
          if (elLi) {
            elLi.classList.add('hide');
          }
        }
  
        if (item == 'review') {
          const reviewDom = document.querySelector(`#judgeme_product_reviews`);
          if (!reviewDom || reviewDom.style.display == 'none') {
            elLi.classList.add('hide');
          }
        }
      })

      handleNav()
    })
  }
  pdpNavigation();

  function handleDdpCardAndCheckout() {
    const btnCheckout = document.querySelector('#footer_checkout');
    const btnAddToCart = document.querySelector('#footer_add_to_cart');

    if (btnCheckout) {
      btnCheckout.onclick = function () {
        const checkoutElem = document.querySelector(
          '.product-page [data-testid="ShopifyPay-button"]'
        );
        if (checkoutElem) {
          checkoutElem.click();
        }
      };
    }

    if (btnAddToCart) {
      btnAddToCart.onclick = function () {
        const adddToCartElem = document.querySelector(
          '.product-page .btn--add-to-cart'
        );
        if (adddToCartElem) {
          adddToCartElem.click();
        }
      };
    }
  }
  handleDdpCardAndCheckout();

  function combosAddToCart() {
    document.querySelectorAll('.look__buy_now').forEach(function (item) {
      let ids = item.getAttribute('data-id');
      if (ids) {
        item.onclick = function () {
          item.classList.add('loading');
          item.setAttribute('aria-busy', true);
          let skus = ids.split(',');
          let formData = skus.map(function (item) {
            return {
              id: item,
              quantity: 1,
            };
          });

          addItemsToCart(formData, function () {
            item.classList.remove('loading');
            item.removeAttribute('aria-busy');
            item.classList.add('has-success');

            new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
              item.classList.remove('has-success');
            });
          });
        };
      } else {
        item.setAttribute('disabled', true);
      }
    });
  }

  combosAddToCart();

  function addItemsToCart(formData, callback) {
    fetch(window.theme.routes.cart + '/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: formData,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        getCart();
        callback && callback();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function getCart() {
    fetch(window.theme.routes.cart_update_url + '.js', {
      method: 'POST',
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: {
              cart: response,
            },
            bubbles: true,
          })
        );

        // open
        let drawerElem = document.querySelector(
          'a.navlink[data-drawer-toggle=drawer-cart]'
        );
        drawerElem.click();
        // let promises = ['api-cart-items', 'api-cart-subtotal'].map(function (item) {
        //   return fetch(window.Shopify.routes.root + '?section_id=' + item, {
        //     method: 'GET',
        //   }).then((response) => response.json());
        // });

        // Promise.all(promises).then(function(result) {
        //   // result
        // }).catch(function(error) {});
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function getCountryList(path) {
    let param = ''
    if (path) {
      param = "?path=" + path;
    }
    fetch(window.theme.routes.api + '/change/shop' + param, {
      method: 'GET',
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.code == 200 && response.data.url) {
          window.location.href = response.data.url;
        }
      });
  }

  function createDatepicker() {
    const el = document.querySelector('[name="customer[note][birthday]"');
    if (el && Datepicker) {
      const datepicker = new Datepicker(el, {
        format: 'yyyy/mm/dd',
        autohide: true,
      });

      datepicker.element.addEventListener('changeDate', () => {
        let elem = el.parentElement.querySelector('label');
        if (el.value.trim()) {
          elem.classList.add('label--float');
        } else if (elem.classList.contains('label--float')) {
          elem.classList.remove('label--float');
        }
      });
    }
  }

  createDatepicker();

  function astraSmoothScroll(e, t) {
    e.preventDefault();
    window.scrollTo({
      top: t,
      left: 0,
      behavior: 'smooth',
    });
  }

  function astScrollToTopHandler(e, t) {
    var a = getComputedStyle(t).content,
      n = t.dataset.onDevices,
      a = a.replace(/[^0-9]/g, '');
    'both' == n || ('desktop' == n && '769' == a) || ('mobile' == n && '' == a)
      ? ((n = window.pageYOffset || document.body.scrollTop),
        e && e.length
          ? n > e.offsetHeight + 100
            ? (t.style.display = 'block')
            : (t.style.display = 'none')
          : 300 < window.pageYOffset
          ? (t.style.display = 'block')
          : (t.style.display = 'none'))
      : (t.style.display = 'none');
  }

  function goTop() {
    let o = document.querySelector('body');
    let l = document.getElementById('ast-scroll-top');
    if (!l) {
      return;
    }
    astScrollToTopHandler(o, l);
    window.addEventListener('scroll', function () {
      astScrollToTopHandler(o, l);
    });
    l.onclick = function (e) {
      astraSmoothScroll(e, 0);
    };

    l.addEventListener('keydown', function (e) {
      'Enter' === e.key && astraSmoothScroll(e, 0);
    });
  }

  goTop();

  async function embedChatbot() {
    if (window.theme.liveChat.live_chat_enable == 'false') {
      return;
    }
    window.difyChatbotConfig = {
      location: window.theme.liveChat.live_chat_country,
      env: window.theme.liveChat.live_chat_mode,
    };
    var t = window.difyChatbotConfig,
      e = document.documentElement.clientWidth || document.body.clientWidth,
      o = document.documentElement.clientHeight || document.body.clientHeight;
    const n = o < e ? '40vw' : '70vw',
      i = o < e ? '40px' : '20%',
      d = Math.min(e - 100, 300) + 'px';
    if (t && t.location) {
      var { location: o, env: e } = t;
      t = {
        TEST: 'https://chatbot-test.aqara.com',
        PROD: 'https://chatbot.aqara.com',
      };
      const l = {
        us: window.theme.liveChat.live_chat_key,
        eu: window.theme.liveChat.live_chat_key,
        ru: '',
        kr: '',
        en: window.theme.liveChat.live_chat_key,
      }[o];
      if (void 0 !== l) {
        const c = t[e] || t.DEV,
          r = `<svg
              id="openIcon"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.7586 2L16.2412 2C17.0462 1.99999 17.7105 1.99998 18.2517 2.04419C18.8138 2.09012 19.3305 2.18868 19.8159 2.43598C20.5685 2.81947 21.1804 3.43139 21.5639 4.18404C21.8112 4.66937 21.9098 5.18608 21.9557 5.74818C21.9999 6.28937 21.9999 6.95373 21.9999 7.7587L22 14.1376C22.0004 14.933 22.0007 15.5236 21.8636 16.0353C21.4937 17.4156 20.4155 18.4938 19.0352 18.8637C18.7277 18.9461 18.3917 18.9789 17.9999 18.9918L17.9999 20.371C18 20.6062 18 20.846 17.9822 21.0425C17.9651 21.2305 17.9199 21.5852 17.6722 21.8955C17.3872 22.2525 16.9551 22.4602 16.4983 22.4597C16.1013 22.4593 15.7961 22.273 15.6386 22.1689C15.474 22.06 15.2868 21.9102 15.1031 21.7632L12.69 19.8327C12.1714 19.4178 12.0174 19.3007 11.8575 19.219C11.697 19.137 11.5262 19.0771 11.3496 19.0408C11.1737 19.0047 10.9803 19 10.3162 19H7.75858C6.95362 19 6.28927 19 5.74808 18.9558C5.18598 18.9099 4.66928 18.8113 4.18394 18.564C3.43129 18.1805 2.81937 17.5686 2.43588 16.816C2.18859 16.3306 2.09002 15.8139 2.0441 15.2518C1.99988 14.7106 1.99989 14.0463 1.9999 13.2413V7.75868C1.99989 6.95372 1.99988 6.28936 2.0441 5.74818C2.09002 5.18608 2.18859 4.66937 2.43588 4.18404C2.81937 3.43139 3.43129 2.81947 4.18394 2.43598C4.66928 2.18868 5.18598 2.09012 5.74808 2.04419C6.28927 1.99998 6.95364 1.99999 7.7586 2ZM10.5073 7.5C10.5073 6.67157 9.83575 6 9.00732 6C8.1789 6 7.50732 6.67157 7.50732 7.5C7.50732 8.32843 8.1789 9 9.00732 9C9.83575 9 10.5073 8.32843 10.5073 7.5ZM16.6073 11.7001C16.1669 11.3697 15.5426 11.4577 15.2105 11.8959C15.1488 11.9746 15.081 12.0486 15.0119 12.1207C14.8646 12.2744 14.6432 12.4829 14.3566 12.6913C13.7796 13.111 12.9818 13.5001 12.0073 13.5001C11.0328 13.5001 10.235 13.111 9.65799 12.6913C9.37138 12.4829 9.15004 12.2744 9.00274 12.1207C8.93366 12.0486 8.86581 11.9745 8.80418 11.8959C8.472 11.4577 7.84775 11.3697 7.40732 11.7001C6.96549 12.0314 6.87595 12.6582 7.20732 13.1001C7.20479 13.0968 7.21072 13.1043 7.22094 13.1171C7.24532 13.1478 7.29407 13.2091 7.31068 13.2289C7.36932 13.2987 7.45232 13.3934 7.55877 13.5045C7.77084 13.7258 8.08075 14.0172 8.48165 14.3088C9.27958 14.8891 10.4818 15.5001 12.0073 15.5001C13.5328 15.5001 14.735 14.8891 15.533 14.3088C15.9339 14.0172 16.2438 13.7258 16.4559 13.5045C16.5623 13.3934 16.6453 13.2987 16.704 13.2289C16.7333 13.1939 16.7567 13.165 16.7739 13.1432C17.1193 12.6969 17.0729 12.0493 16.6073 11.7001ZM15.0073 6C15.8358 6 16.5073 6.67157 16.5073 7.5C16.5073 8.32843 15.8358 9 15.0073 9C14.1789 9 13.5073 8.32843 13.5073 7.5C13.5073 6.67157 14.1789 6 15.0073 6Z"
                fill="#121212"
              />
            </svg>`,
          s = `<svg
            id="closeIcon"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 18L6 6M6 18L18 6"
              stroke="#121212"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>`;
        if (!document.getElementById('dify-chatbot-bubble-button')) {
          o = document.createElement('button');
          (o.id = 'dify-chatbot-bubble-button'),
            (o.type = 'button'),
            o.setAttribute('aria-label', 'Open customer support chat'),
            o.setAttribute('aria-expanded', 'false'),
            o.setAttribute('aria-controls', 'dify-chatbot-bubble-window'),
            (o.style.cssText =
              'position: fixed; bottom: 120px; right: 21px; width: 3.4rem; height: 3.4rem; padding: 0; border: 0; border-radius: 50%; background-color: #FFF; color: inherit; font: inherit; box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 20%); cursor: pointer; z-index: 200; transition: all 0.2s ease-in-out 0s; left: unset; transform: scale(1);');
          const a = document.createElement('div');
          (a.style.cssText =
            'display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; z-index: 20;'),
            (a.innerHTML = r),
            o.appendChild(a),
            document.body.appendChild(o),
            o.addEventListener('click', function () {
              if (!l) {
                window.top.open(window.theme.liveChat.contact_us_url, '_blank');
                return;
              }
              let chatWindow = document.getElementById('dify-chatbot-bubble-window');
              const willOpen = !chatWindow || chatWindow.style.display === 'none';
              if (!chatWindow) {
                chatWindow = document.createElement('iframe');
                chatWindow.allow = 'fullscreen;microphone';
                chatWindow.title = 'Customer support chat';
                chatWindow.id = 'dify-chatbot-bubble-window';
                chatWindow.src = c + '/chatbot/' + l;
                chatWindow.style.cssText = `border: none; position: fixed; flex-direction: column; justify-content: space-between; box-shadow: rgba(150, 150, 150, 0.2) 0px 10px 30px 0px, rgba(150, 150, 150, 0.2) 0px 0px 0px 1px; bottom: 20px; right: 85px; width:${n}; min-width: ${d}; height: calc(100vh - ${i});max-width:639px;border-radius: 0.75rem; display: flex; z-index: 99999; overflow: hidden; left: unset; background-color: #F3F4F6;`;
                document.body.appendChild(chatWindow);
              } else {
                chatWindow.style.display = willOpen ? 'flex' : 'none';
              }
              a.innerHTML = willOpen ? s : r;
              o.setAttribute('aria-expanded', String(willOpen));
              o.setAttribute(
                'aria-label',
                willOpen ? 'Close customer support chat' : 'Open customer support chat'
              );
            });
        }
      }
    } else
      console.error('difyChatbotConfig is empty or location is not provided');
  }
  embedChatbot();

  function changeCountry() {
    let countryList = document.querySelectorAll(
      '#country-list-localization-form-toolbar .popout-list__item'
    );

    document.addEventListener('theme:change:site', function (event) {
      let path = event.detail.path;
      getCountryList(path);
    });

    let lanList = document.querySelectorAll(
      '#lang-list-localization-form-toolbar .popout-list__item'
    );

    countryList.forEach((item, index) => {
      const aDom = item.querySelector('.popout-list__option');
      aDom.style.transitionDelay = `${index * 50 + 10}ms`;
    });

    lanList.forEach((item, index) => {
      const aDom = item.querySelector('.popout-list__option');
      aDom.style.transitionDelay = `${index * 50 + 10}ms`;
    });
  }
  changeCountry();

  function verifyEmail() {
    let verifyBtn = document.getElementById('verifyBtn');
    if (verifyBtn) {
      verifyBtn.onclick = function() {
        verifyBtn.classList.add('disabled');

        fetch(window.theme.routes.api + '/verifyemail').then(function(response) {
          console.log(response.ok)
          if (response.ok) {
            return response.json();
          }
        }).then(function(response) {
          console.log(response.data)
          if (response.code == 200) {
            if (response.data && response.data.status == 200) {
              document.querySelector('.account-email-success').classList.remove('hide');
            } else {
              verifyBtn.classList.remove('disabled');
              document.querySelector('.account-email-error').classList.remove('hide');
            }
          } else {
            verifyBtn.classList.remove('disabled');
            document.querySelector('.account-email-error').classList.remove('hide');
          }
        })
      }
    }
  }

  verifyEmail();

  function getCurrentRemain() {
    let el = document.querySelector('#current-remain')
    if (el) {
      fetch(window.theme.routes.api + '/current-remain?email='+ el.dataset.email).then(function(response) {
        if (response.ok) {
          return response.json();
        }
      }).then(function(response) {
        if (response.data && response.data.length > 0) {
          let arr = []
          response.data.forEach((item) => {
            arr.push(item.name + ': ' + item.remain_quota)
          });
          el.innerHTML =  arr.join('.')
        }
      })
    }
  }

  getCurrentRemain()
  
  // function useCoupon () {
  //   var response = fetch(GRAPHQL_ENDPOINT, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Access-Control-Allow-Origin': '*',
  //     },
  //     body: JSON.stringify({
  //       query: query,
  //       operationName: 'countries',
  //       variables: {
  //         locale: toSupportedLocale(locale),
  //       },
  //     })
  // }
})();
